// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"icon_tcnqh","recognisedMessages":"recognisedMessages_gmmt7","unrecognisedMessages":"unrecognisedMessages_RlSrY","title":"title_uIMya"};